import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { LEAD_MANAGEMENT } from '@constants/routes';

import LeadList from './pages/lead-list/LeadList';
import LeadDetails from './pages/LeadDetails';
import LeadReports from './pages/LeadReports';
import LeadSettings from './pages/LeadSettings';

const LeadManagementDashboard = lazy(
  () => import('@features/lead-management/pages/LeadManagementDashboard')
);

const LeadAdd = lazy(() => import('@features/lead-management/pages/LeadAdd'));

const LeadActivities = lazy(
  () => import('@features/lead-management/pages/LeadActivities')
);

export const LeadManagementRoutes: RouteObject[] = [
  {
    path: LEAD_MANAGEMENT.HOME,
    children: [
      {
        path: LEAD_MANAGEMENT.LEAD_DASHBOARD,
        element: <LeadManagementDashboard />
      },
      {
        path: LEAD_MANAGEMENT.LEAD_LIST,
        element: <LeadList />
      },
      {
        path: LEAD_MANAGEMENT.LEAD_ACTIVITIES,
        element: <LeadActivities />
      },
      {
        path: LEAD_MANAGEMENT.LEAD_ADD,
        element: <LeadAdd />
      },
      {
        path: LEAD_MANAGEMENT.LEAD_EDIT,
        element: <LeadAdd />
      },
      {
        path: LEAD_MANAGEMENT.LEAD_SETTINGS,
        element: <LeadSettings />
      },
      {
        path: LEAD_MANAGEMENT.LEAD_REPORTS,
        element: <LeadReports />
      },
      {
        path: LEAD_MANAGEMENT.LEAD_DETAILS,
        element: <LeadDetails />
      }
    ]
  }
];

export default LeadManagementRoutes;
